import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/shared/services/REST-API/rest.service';

@Component({
  selector: 'app-leader-board',
  templateUrl: './leader-board.component.html',
  styleUrls: ['./leader-board.component.css']
})
export class LeaderBoardComponent implements OnInit {
  singleLeadersBoard;
  constructor(private authApi: AuthService) { }

  ngOnInit() {
    this.authApi.getSingleLeadersBoard().subscribe((data) => {
      this.singleLeadersBoard = data;
    })
  }

}
